import styled from 'styled-components'
import Link from '../../../components/router/Link'
import { StyledTooltip } from '../../../components/general/Tooltip'

const FormatLink = styled(Link)`
	align-items: center;
	display: inline-flex;

	${StyledTooltip} {
		margin-left: 0.15rem;
	}

	${StyledTooltip}, svg {
		height: 16px;
		width: 16px;
	}
`

export default FormatLink
